<template>
  <div class="manager-flex">
    <div class="pages--top-flex">
      <div class="header flex-between">
        <div class="header-text">
          <h1>微信换绑审核</h1>
        </div>
        <div class="header-button">
          <el-button
            v-if="jurisdiction.search"
            icon="iconfont icon-sousuo1"
            @click="Query"
            >查询</el-button
          >
          <el-button v-if="jurisdiction.search" @click="eliminate"
            >清除查询条件</el-button
          >
          <el-button v-if="jurisdiction.toExamine" @click="toExamine"
            >审核</el-button
          >
        </div>
      </div>
      <el-card shadow="never">
        <div class="searchform">
          <el-form size="small" label-width="100px">
            <el-row>
              <el-col :span="5">
                <el-form-item label="会员卡号\姓名\手机号" label-width="160px">
                  <el-input v-model="queryInfo.serach"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="维护店">
                  <el-input v-model="queryInfo.shopCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="当前维护人" label-width="120px">
                  <el-input v-model="queryInfo.empCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="状态">
                  <el-select style="width: 100%" v-model="queryInfo.state">
                    <el-option
                      v-for="item in stateList"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="centercard">
      <el-card shadow="never">
        <el-table
          :height="isMore ? 'calc(100vh - 24.3rem)' : 'calc(100vh - 22rem)'"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="MagerTable"
          :data="dataSource"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="(row) => row.id"
          @sort-change="sortChange"
          @selection-change="selectionChange"
          v-el-table-infinite-scroll="PageTouchTheBottom"
          infinite-scroll-disabled="infiniteScrollDisabledIs"
          v-loading="loading"
        >
          <el-table-column
            type="selection"
            width="60"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column type="index" width="60"></el-table-column>
          <el-table-column
            prop="name"
            label="会员姓名"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="cardNo"
            width="120"
            sortable="custom"
            label="会员卡号"
          >
          </el-table-column>
          <el-table-column prop="levelName_cn" label="会员等级" width="120">
          </el-table-column>
          <el-table-column prop="regionName" label="所属区域" width="120">
          </el-table-column>
          <el-table-column prop="shopCode" label="所属门店" width="100">
          </el-table-column>
          <el-table-column
            prop="empCode"
            label="维护人"
            sortable="custom"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="OrigUnionID"
            label="原unionid"
            sortable="custom"
            minWidth="200"
          >
          </el-table-column>
          <el-table-column
            prop="NewUnionID"
            label="改绑unionid"
            sortable="custom"
            minWidth="200"
          >
          </el-table-column>
          <el-table-column prop="state" label="状态" width="100">
            <template slot-scope="scope">
              {{ statList[scope.row.state] }}
            </template>
          </el-table-column>
          <el-table-column prop="reviewEmpCode" label="审核人" width="150">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="申请日期"
            sortable="custom"
            width="160"
          >
            <template slot-scope="scope">
              {{ renderTime(scope.row.createTime || "") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ReviewTime"
            label="审核日期"
            sortable="custom"
            width="160"
          >
            <template slot-scope="scope">
              {{ renderTime(scope.row.ReviewTime || "") }}
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
    <div class="establish">
      <el-dialog
        :close-on-click-modal="false"
        title="审核提示"
        :visible.sync="toExaminedialogVisible"
        width="20%"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">审核</span>此微信绑定?
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="bindWxClick">审核</el-button>
          <el-button @click="bindWxrRefuseClick">拒绝</el-button>
          <el-button @click="toExaminedialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        title="审核结果"
        @close="findingOfAuditclose"
        :visible.sync="findingOfAudit"
        width="60%"
      >
        <el-table
          height="calc(100vh - 40rem)"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          :data="dataSourceOfAudit"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column type="index" width="60"></el-table-column>
          <el-table-column
            prop="name"
            label="会员姓名"
            width="120"
          ></el-table-column>
          <el-table-column prop="cardNo" width="120" label="会员卡号">
          </el-table-column>
          <el-table-column prop="levelName_cn" label="会员等级" width="120">
          </el-table-column>
          <el-table-column prop="OrigUnionID" label="原unionid" minWidth="200">
          </el-table-column>
          <el-table-column prop="NewUnionID" label="改绑unionid" minWidth="200">
          </el-table-column>
          <el-table-column prop="state" label="当前状态" width="100">
            <template slot-scope="scope">
              {{ statList[scope.row.state] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="findingOfAuditState"
            label="审核结果"
            width="100"
          >
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const statList = {
  0: "已审核",
  1: "已拒绝",
  2: "未审核",
};
const sortList = {
  cardNo: "1",
  empCode: "2",
  OrigUnionID: "3",
  NewUnionID: "4",
  createTime: "5",
  ReviewTime: "6",
};
import {
  queryReqbindunionList,
  bindBatchWx,
  bindWxrBatchRefuse,
} from "@/api/viewMemberModule";
export default {
  data() {
    return {
      stateList: [
        { id: "", value: "全部" },
        { id: "0", value: "已审核" },
        { id: "1", value: "已拒绝" },
        { id: "2", value: "未审核" },
      ],
      toExaminedialogVisible: false,
      findingOfAudit: false,
      dataSourceOfAudit: [],
      SelectChang: [],
      loading: false,
      queryInfo: {
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        serach: "",
        shopCode: "",
        empCode: "",
        state: "",
      },
      statList,
      dataSource: [],
      jurisdiction: {
        search: false,
        toExamine: false,
      },
      sortList,
    };
  },
  computed: {
    isMore() {
      return this.queryInfo.pageNo >= this.queryInfo.pagesTotal;
    },
    infiniteScrollDisabledIs() {
      return this.loading || this.isMore;
    },
  },
  created() {
    this.getInfoList();
    let WeChatBindingChange = JSON.parse(
      localStorage.getItem("WeChatBindingChange")
    );
    for (let i = 0; i < WeChatBindingChange.length; i++) {
      if (WeChatBindingChange[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (WeChatBindingChange[i].menuName == "审核") {
        this.jurisdiction.toExamine = true;
        continue;
      }
    }
  },
  methods: {
    findingOfAuditclose() {
      this.SelectChang = [];
      this.dataSourceOfAudit = [];
    },
    sortChange(e) {
      this.queryInfo.orderBy = this.sortList[e.prop];
      this.queryInfo.sort =
        e.order == "ascending" ? 1 : e.order == "descending" ? 0 : "";
      this.queryInfo.pageNo = 1;
      this.queryInfo.pagesTotal = 0;
      if (this.queryInfo.sort === "") this.queryInfo.orderBy = "";
      this.getInfoList();
    },
    bindWxrRefuseClick() {
      bindWxrBatchRefuse(this.SelectChang.map((item) => item.id)).then(
        (res) => {
          if (res.success) {
            let SelectChang = JSON.parse(JSON.stringify(this.SelectChang));
            if (res.data.length > 0) {
              if (res.data.length > 0) {
                res.data.forEach((item) => {
                  if (item[Object.keys(item)[0]] == "success") {
                    let dataSourceIndex = this.dataSource.findIndex(
                      (Fi) => Fi.id == Object.keys(item)[0]
                    );
                    if (dataSourceIndex != -1) {
                      this.dataSource[dataSourceIndex].state = 1;
                    }
                    let SelectChangIndex = SelectChang.findIndex(
                      (Fi) => Fi.id == Object.keys(item)[0]
                    );
                    if (SelectChangIndex != -1) {
                      SelectChang[SelectChangIndex].state = 1;
                      SelectChang[SelectChangIndex]["findingOfAuditState"] =
                        "成功";
                    }
                  } else {
                    let SelectChangIndex = SelectChang.findIndex(
                      (Fi) => Fi.id == Object.keys(item)[0]
                    );
                    if (SelectChangIndex != -1) {
                      SelectChang[SelectChangIndex]["findingOfAuditState"] =
                        "失败";
                    }
                  }
                });
              }
            }
            this.dataSourceOfAudit = SelectChang;
            this.$refs.MagerTable.clearSelection();
            this.SelectChang = [];
            this.toExaminedialogVisible = false;
            this.findingOfAudit = true;
            this.$message({
              type: "success",
              message: "拒绝成功！",
            });
          }
        }
      );
    },
    bindWxClick() {
      bindBatchWx(this.SelectChang.map((item) => item.id)).then((res) => {
        if (res.success) {
          let SelectChang = JSON.parse(JSON.stringify(this.SelectChang));
          if (res.data.length > 0) {
            if (res.data.length > 0) {
              res.data.forEach((item) => {
                if (item[Object.keys(item)[0]] == "success") {
                  let dataSourceIndex = this.dataSource.findIndex(
                    (Fi) => Fi.id == Object.keys(item)[0]
                  );
                  if (dataSourceIndex != -1) {
                    this.dataSource[dataSourceIndex].state = 0;
                  }
                  let SelectChangIndex = SelectChang.findIndex(
                    (Fi) => Fi.id == Object.keys(item)[0]
                  );
                  if (SelectChangIndex != -1) {
                    SelectChang[SelectChangIndex].state = 0;
                    SelectChang[SelectChangIndex]["findingOfAuditState"] =
                      "成功";
                  }
                } else {
                  let SelectChangIndex = SelectChang.findIndex(
                    (Fi) => Fi.id == Object.keys(item)[0]
                  );
                  if (SelectChangIndex != -1) {
                    SelectChang[SelectChangIndex]["findingOfAuditState"] =
                      "失败";
                  }
                }
              });
            }
          }
          this.dataSourceOfAudit = SelectChang;
          this.$refs.MagerTable.clearSelection();
          this.SelectChang = [];
          this.toExaminedialogVisible = false;
          this.findingOfAudit = true;
          this.$message({
            type: "success",
            message: "审核成功！",
          });
        }
      });
    },
    eliminate() {
      this.$refs.MagerTable.clearSelection();
      this.SelectChang = [];
      this.queryInfo = this.$options.data.call(this).queryInfo;
      this.$message.success("清除查询条件成功!");
      this.getInfoList();
    },
    toExamine() {
      if (this.SelectChang.length > 0) {
        this.toExaminedialogVisible = true;
      } else {
        this.$message({
          message: "请选择对应数据再进行审核！",
          type: "warning",
        });
      }
    },
    renderTime(date) {
      if (date) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    PageTouchTheBottom() {
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.getInfoList(false);
      }, 1000);
    },
    selectionChange(selection) {
      selection.forEach((item) => {
        if (item.state != 2) {
          this.$refs.MagerTable.toggleRowSelection(item, false);
        }
      });
      this.SelectChang = selection.filter((item) => item.state == 2);
    },
    getInfoList(pagingType = true) {
      this.loading = true;
      let params = {};
      for (const key in this.queryInfo) {
        if (this.queryInfo[key] || [0, "0"].includes(this.queryInfo[key]))
          params[key] = this.queryInfo[key];
      }
      queryReqbindunionList(require("qs").stringify(params))
        .then((res) => {
          if (res.success) {
            if (pagingType) this.dataSource = [];
            this.dataSource = this.dataSource.concat(res.data.list);
            this.queryInfo.pagesTotal = res.data.pages;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    Query() {
      this.queryInfo.pageNo = 1;
      this.queryInfo.pagesTotal = 0;
      this.getInfoList();
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.State-flex-checkbox {
  margin-top: 6px;
}
.search-div {
  padding-right: 25px;
  display: flex;
  justify-content: flex-end;
}
.updelu-image:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.updelu-image {
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  line-height: 80px;
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border: 1px solid #cccccc;
}
.pages--top-flex {
  display: flex;
  flex-direction: column;
}
.manager-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.centercard {
  margin-top: 10px;
}
.searchform {
  margin-top: 20px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角
/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }

  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .establish {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-dialog__body {
      padding: 20px 60px;
    }
    .el-input__inner {
      //   width: 300px;
    }
    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__active-bar {
      height: 0;
    }
    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
